export default "__VITE_ASSET__D38rW7q7__"